import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import usePageTitle from '@/shared/hooks/usePageTitle';

// The catch-all route's element. Without it an unmatched path renders an empty
// main element, which reads as a broken page rather than a wrong address.
function NotFoundPage() {
    usePageTitle('Page not found');
    return (
        <Container className="py-5">
            <h1>Page not found</h1>
            <p>
                That address does not match anything on the exchange. It may
                have moved, or the listing may have been removed.
            </p>
            <Link to="/">Go to the home page</Link>
        </Container>
    );
}

export default NotFoundPage;
